import { render, staticRenderFns } from "./CustomPopover.vue?vue&type=template&id=348a6b24&scoped=true&"
import script from "./CustomPopover.vue?vue&type=script&lang=js&"
export * from "./CustomPopover.vue?vue&type=script&lang=js&"
import style0 from "./CustomPopover.vue?vue&type=style&index=0&id=348a6b24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348a6b24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
